import { useLanguageAwareRouting } from '@gofranz/common-components';
import { NavLink } from '@mantine/core';
import {
  IconCreditCard,
  IconHelp,
  IconLogout,
  IconMessage,
  IconSettings,
} from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useRustyState } from '../../state';

export function AccountNavigation() {
  const { t } = useTranslation();
  const { createLanguageURL } = useLanguageAwareRouting();

  const logout = async () => {
    await useRustyState.getState().logout();
    window.location.replace(createLanguageURL('/'));
  };

  return (
    <>
      <NavLink
        component={Link}
        to={createLanguageURL('/chat')}
        label="Chat"
        leftSection={<IconMessage size="18" stroke={1.5} />}
      />
      <NavLink
          component={Link}
          to={createLanguageURL('/account/billing/usage')}
          label="Usage & Credits"
        leftSection={<IconCreditCard size="18" stroke={1.5} />}
      />
      <NavLink
        component={Link}
        to={createLanguageURL('/account/profile')}
        label={t('glob_navigation.profile')}
        leftSection={<IconSettings size="18" stroke={1.5} />}
      />
      <NavLink
        component={Link}
        to={createLanguageURL('/account/support')}
        label={t('glob_navigation.support')}
        leftSection={<IconHelp size="18" stroke={1.5} />}
      />
      <NavLink
        onClick={logout}
        href="#"
        label={t('glob_navigation.logout')}
        leftSection={<IconLogout size="18" stroke={1.5} />}
      />
    </>
  );
}
